import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Oval } from "react-loader-spinner";
import { API_URL } from "../../shared/constant";
import axios from "axios";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

const SubCategory = () => {
  const [subCategoryData, setSubCategoryData] = useState([]);
  const [loading, setLoading] = useState(true);

  const getSubCategory = () => {
    axios.post(API_URL.SUB_CATEGORY_LIST, { is_seller: [0, 1] }).then(
      (res) => {
        if (res.data.status === 1) {
          setSubCategoryData(res.data.data);
        }
        setLoading(false);
      },
      (error) => {
        setLoading(false);
        toast.error("Something went wrong..", {
          autoClose: 3000,
          position: "top-right",
        });
      }
    );
  };

  const deleteSubCategory = (row) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this - " + row.name,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        axios.post(API_URL.SUB_CATEGORY_DELETE, { id: row.id }).then(
          (res) => {
            if (res.data.status === 1) {
              let newData = subCategoryData.filter((r) => r.id != row.id);
              setSubCategoryData(newData);
            }
            toast.success(row.name + " Delete Successfully", {
              autoClose: 3000,
              position: "top-right",
            });
            setLoading(false);
          },
          (error) => {
            setLoading(false);
            toast.error("Something went wrong..", {
              autoClose: 3000,
              position: "top-right",
            });
          }
        );
      }
    });
  };

  useEffect(() => {
    getSubCategory();
  }, []);

  return (
    <>
      <div className="page-header">
        <div className="content-page-header">
          <h5>SubCategory({subCategoryData.length})</h5>
          <div className="list-btn">
            <ul className="filter-list">
              <li>
                <Link to={"/admin/subcategory/add"} className="btn btn-primary">
                  <i className="fa fa-plus-circle me-2" aria-hidden="true"></i>
                  Add SubCategory
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12">
          <div className="card-table">
            <div className="card-body">
              {loading ? (
                <Oval
                  height={60}
                  width={60}
                  color="#7539ff"
                  wrapperStyle={{ justifyContent: "center" }}
                  wrapperClass=""
                  visible={true}
                  ariaLabel="oval-loading"
                  secondaryColor="#7539ff"
                  strokeWidth={2}
                  strokeWidthSecondary={2}
                />
              ) : (
                <div className="table-responsive">
                  <table className="table table-center table-hover datatable">
                    <thead className="thead-light">
                      <tr>
                        <th>#</th>
                        <th>Image</th>
                        <th>Name</th>
                        <th className="text-center">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {subCategoryData.map((row, key) => {
                        return (
                          <tr key={key}>
                            <td>{key + 1}</td>
                            <td><div
                                  style={{ height: "50px",maxWidth:"50px"
                                    ,backgroundImage: "url(" + row.image + ")",
                                  }}
                                ></div></td>

                            <td>
                              <h2 className="table-avatar">{row.name}</h2>
                            </td>
                            <td>
                              <Link
                                to={"/admin/subcategory/edit/" + row.id}
                                className="btn btn-sm btn-secondary me-2"
                              >
                                <i className="fa fa-edit me-1"></i> Edit
                              </Link>
                              <button
                                onClick={() => deleteSubCategory(row)}
                                className="btn btn-sm btn-danger me-2"
                              >
                                <i className="fa fa-trash me-1"></i> Delete
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SubCategory;
